import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const onboardingTypeOptions1 = [
  { label: "Regular Onboarding", value: "REGULAR_ONBOARDING" },
  { label: "Direct Onboarding", value: "DIRECT_ONBOARDING" },
  {
    label: "Onboarding without Document",
    value: "ONBOARDING_WITHOUT_DOCUMENTS",
  },
];
const rows = [
  createData("1", "Profile Evaluation", "Initial Buyer"),
  createData(
    "2",
    "Financial Evaluation ",
    <select className="form-select react_controlpaneles_select">
      <option>Select</option>
      <option>Select</option>
    </select>
  ),
  createData(
    "3",
    "Factory Evaluation",
    <select className="form-select react_controlpaneles_select">
      <option>Select</option>
      <option>Select</option>
    </select>
  ),
  createData("4", "Final Rating", "Automatically Calculated"),
  createData("5", "3rd Party Evaluation", "Initial Buyer"),
  createData(
    "6",
    "Additional SAP Fields",
    <select className="form-select react_controlpaneles_select">
      <option>Select</option>
      <option>Select</option>
    </select>
  ),
];
const row1 = [
  createData("1", "Profile Evaluation", "Initial Buyer"),
  createData(
    "2",
    "Financial Evaluation ",
    <select className="form-select react_controlpaneles_select">
      <option>Select</option>
      <option>Select</option>
    </select>
  ),
  createData("3", "3rd Party Evaluation", "Initial Buyer"),
  createData(
    "4",
    "Additional SAP Fields",
    <select className="form-select react_controlpaneles_select">
      <option>Select</option>
      <option>Select</option>
    </select>
  ),
];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Regularonboarding(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [tabArr, setTabArr] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});
  const [selectedPageOption, setPageSelectedOption] = useState({});
  const [tableDetails, setTableDetails] = useState({ sections: [] });
  const [sectionAssignData, setSectionAssignData] = useState([]);

  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });

  // useEffect(() => {
  //   getAssignSteps();
  // }, []);


  const onAssigneeChange = (e, row, index) => {
    props?.onAssigneeChange(e.target.value, row, index)
  };


  return (
    <>
      <div class="text-centers pt-3">
        <TableContainer className="mb-3" component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell className="table_react_listing_controlpanel_block">
                  Step No.
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className="table_react_listing_controlpanel_block"
                >
                  Step Name
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  className="table_react_listing_controlpanel_block"
                >
                  Default Assignee
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props?.tabArr.map((row, index) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell
                    className="cell_tabel_controlpanel_listing_blockss"
                    component="th"
                    scope="row"
                  >
                    {index + 1}
                  </StyledTableCell>

                  <StyledTableCell
                    align="left"
                    className="cell_tabel_controlpanel_listing_blockss"
                  >
                    {row.progressName} Evaluation
                  </StyledTableCell>

                  {(row?.isEdit == false) && <StyledTableCell
                    align="left"
                    className="cell_tabel_controlpanel_listing_blockss"
                  >
                    {row.defaultAssignee}
                  </StyledTableCell>}

                  {(row?.isEdit == true) && <StyledTableCell
                    align="left"
                    className="cell_tabel_controlpanel_listing_blockss"
                  >
                    <select
                      className="form-select react_controlpaneles_select"
                      onChange={(e) => onAssigneeChange(e, row, index)}
                      // value={row?.defaultAssignee}
                      value={(row?.defaultAssignee !== null) ? row?.defaultAssignee : ''}
                    >
                      <option value={""} disabled>Please Select</option>
                      {props?.sectionAssignData?.map((option, index) => (
                        <option key={index} value={option?._id}>
                          {option?.name}
                        </option>
                      ))}
                    </select>
                  </StyledTableCell>}

                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <div className="clear_btn_status_block_react_controlpanels">
            <button
              type="button"
              className="clear_btn_status_block_lists"
              data-dismiss="modal"
              fdprocessedid="0y9izm"
            >
              Clear
            </button>
            <button
              type="button"
              className="btn btn-success save_next_btns"
              fdprocessedid="ao4xc"
            >
              Submit
            </button>
          </div> */}
      </div>
    </>
  );
}

export default Regularonboarding;
